export default __webpack_public_path__ + "static/media/boy.4aed76bd.jpg";